/* eslint-disable camelcase */
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { modelToDto } from './mapper';
import type { SignInSubmitDataModel, SignInResponseDto } from './model';

const PATH = '/api/v1/enterprise-sso/login-start';

export async function loginSsoUser(
  payload: SignInSubmitDataModel,
): Promise<AxiosResponse<SignInResponseDto>> {
  const response = await axios.post<SignInResponseDto, AxiosResponse<SignInResponseDto>>(
    PATH,
    modelToDto(payload),
  );

  return response;
}
